define.alias("shared/decorators/track-call-duration", "media/decorators/track-call-duration");